import { AppFormItem, AppFormItemProps, AppBaseSelect, AppBaseSelectProps } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { timetableTexts } from 'consts/text';
import { Repetition, SelectOptionType } from 'types';

const options: SelectOptionType<Repetition>[] = [
    {
        label: timetableTexts.lessons.lessonsRepetitionLabels.everyDay,
        value: 'EVERY_DAY',
    },
    {
        label: timetableTexts.lessons.lessonsRepetitionLabels.workingDays,
        value: 'WORKING_DAYS',
    },
    {
        label: timetableTexts.lessons.lessonsRepetitionLabels.everyWeek,
        value: 'EVERY_WEEK',
    },
    {
        label: timetableTexts.lessons.lessonsRepetitionLabels.everyTwoWeeks,
        value: 'EVERY_2_WEEKS',
    },
    {
        label: timetableTexts.lessons.lessonsRepetitionLabels.everyMonth,
        value: 'EVERY_MONTH',
    },
];

type RepetitionPickerElementProps = AppFormItemProps &
    Pick<AppBaseSelectProps, 'allowClear'> & {
        disabled?: boolean;
    };

export const RepetitionPickerElement = ({
    disabled,
    allowClear,
    ...props
}: RepetitionPickerElementProps) => (
    <AppFormItem
        label={timetableTexts.lessons.lessonsRepetition}
        name={formFields.repetition}
        initialValue={options[0].value}
        {...props}
    >
        <AppBaseSelect
            disabled={disabled}
            allowClear={allowClear}
            options={options}
            placeholder="Wybierz typ powtarzania"
        />
    </AppFormItem>
);
